import React from 'react';
import './ErrorState.scss';

/**
 * Error state component
 * @param {Object} props
 * @param {string} props.title - Error title
 * @param {string} props.message - Error message
 * @param {Function} props.onRetry - Retry callback function
 * @param {string} props.retryText - Retry button text
 * @param {boolean} props.showRetry - Whether to show retry button
 */
const ErrorState = ({ 
  title = 'Loading Failed',
  message = 'An unknown error occurred, please try again',
  onRetry,
  retryText = 'Reload',
  showRetry = true
}) => {
  return (
    <div className="error-state">
      <div className="error-content">
        <div className="error-icon" aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <path 
              d="M24 4C12.96 4 4 12.96 4 24C4 35.04 12.96 44 24 44C35.04 44 44 35.04 44 24C44 12.96 35.04 4 24 4Z" 
              fill="#dc3545"
            />
            <path 
              d="M24 14V26M24 30H24.02" 
              stroke="white" 
              strokeWidth="3" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </div>
        
        <h3 className="error-title">{title}</h3>
        <p className="error-message" role="alert">{message}</p>
        
        {showRetry && onRetry && (
          <button 
            className="retry-button"
            onClick={onRetry}
            type="button"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path 
                d="M1 4V10C1 11.1046 1.89543 12 3 12H13C14.1046 12 15 11.1046 15 10V6C15 4.89543 14.1046 4 13 4H3C1.89543 4 1 4.89543 1 6V4Z" 
                stroke="currentColor" 
                strokeWidth="1.5"
              />
              <path 
                d="M4 8L8 6L12 8" 
                stroke="currentColor" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
            {retryText}
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorState;